import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomSidePanel from "../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../components/button";
import CustomSwitch from "../../../components/custom-form/switch";
import * as gatewayAndPriceActions from "../store/actions/gateway_and_price_list_whatsapp_actions";

export default function WhatsappPrice2SidePanel({ show, gatewayAndPriceData, loadingData, handleClose }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    const tempFormData = {
      price: gatewayAndPriceData.price,
      isApplyForAllUsers: false,
    };
    setFormData(tempFormData);
  }, [gatewayAndPriceData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: gatewayAndPriceData._id,
      loadingData,
      data: {
        updateData: {
          price: formData.price,
        },
        isApplyForAllUsers: formData.isApplyForAllUsers
      },
    };
    dispatch(gatewayAndPriceActions.editWhatsappPrice2Request(payload));
    handleClose();
  };
  const handleChange = (inputKey, inputValue) => {
    setFormData((prev) => {
      return {
        ...prev,
        [inputKey]: inputValue,
      };
    });
  };
  return (
    <CustomSidePanel
      show={show}
      title={"Country Name: " + gatewayAndPriceData.countryName}
      moduleName="Gateway And Price"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >

      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{`Country Name: ${gatewayAndPriceData.countryName}`}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay {...{ formData, handleChange, handleClose, handleSubmit }} />
      </div>
    </CustomSidePanel>
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Row>
        <Col className="form-group" xs={12}>
          <label className="form-label text-gray-700">Price</label>
          <Form.Control type="number" value={formData.price ?? 0} onChange={(e) => handleChange("price", e.target.value)} />
        </Col>
      </Row>
      <Form.Group>
        <CustomSwitch
          label="Apply for all users"
          id="apply-for-all-users"
          checked={formData.isApplyForAllUsers}
          handleChange={(e) => {
            handleChange("isApplyForAllUsers", e.target.checked);
          }}
        />
      </Form.Group>

      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
